import React, { useState, useContext } from 'react';
import { Context } from '../../../context';
import Modal from '../../shared/Modal/Modal';
import { ReactComponent as Close } from '../../../assets/images/close.svg';
const DevTipItems = ({ notification, onOpen }) => {
  const [showModule, setShowModal] = useState(false);
  const context = useContext(Context);

  const handleClose = () => {
    setShowModal(false);
    context.checkDevTips(notification.module, notification.id, 'dismissed');
  };

  return (
    <>
      <div
        className='tip-wrapper'
        onClick={(e) => {
          e.stopPropagation();
          setShowModal(true);
          onOpen?.();
          context.closeMenu();
          context.checkDevTips(notification.module, notification.id, 'opened');
        }}
      >
        <p>{notification.title}</p>
        <button
          className='closeNoti'
          onClick={(e) => {
            e.stopPropagation();
            context.checkDevTips(notification.module, notification.id, 'dismissed');
            context.closeMenu();
          }}
        >
          <Close />
        </button>
      </div>

      <Modal
        show={showModule}
        showModal={handleClose}
        portalToBody
      >
        <div className='devtip-wrap'>
          <div className='head'>
            <div className='icon'></div>
          </div>
          <div
            className='devtip-content'
            dangerouslySetInnerHTML={{ __html: notification.content }}
          ></div>
        </div>
      </Modal>
    </>
  );
};

export default DevTipItems;
